import "./portfolio.css";

import IMG1 from "../../assets/arogya.png";
import IMG2 from "../../assets/calculator.png";
import IMG3 from "../../assets/guess.png";
import IMG4 from "../../assets/amazon.png";
import IMG5 from "../../assets/BMI.png";
import IMG6 from "../../assets/password.png";
import React from "react";

//Portfolio function
const Portfolio = () => {
  const soloProjects = [
    {
      id: 1,
      title: "Diet & Workout Recommendation",
      img: IMG1,
      description:
        "it is a web application that provides personalized diet & workout.",
      technologies: "Html | CSS | Python",
      link: "https://db64a608-a9a5-4e83-846d-87a9d97cf1ba-00-pk3nknml9oa4.pike.replit.dev/",
      github: "https://github.com/Vishal-k123/Arogya-life",
    },
    {
      id: 2,
      title: "Amazon UI",
      img: IMG4,
      description:
      "it is a front-end clone of the Amazon website, built using HTML and CSS.",
      technologies: "HTML | CSS ",
      link: "https://amazone-clone-fontend-32n8.vercel.app//",
      github: "https://github.com/Vishal-k123/Amazone_clone_Fontend",
    },
    {
      id: 3,
      title: "Calculator",
      img: IMG2,
      description: 
        "A calculator is a device that performs arithmetic operations on numbers.",
      technologies: "HTML | CSS | JavaScript",
      link: "https://html-chai-2to3.vercel.app/",
      github: "https://github.com/Vishal-k123/Calculator",
    },
    {
      id: 4,
      title: "Guess the Number Game",
      img: IMG3,
      description:
        "it is a simple number guessing game built using HTML, CSS, and JavaScript.",
      technologies: "Html | CSS | JavaScript ",
      link: "https://js-projects-wpoo.vercel.app/",
      github: "https://github.com/Vishal-k123/js-Projects/tree/main/07_Projects/Guess_Number",
    },
    {
      id: 5,
      title: "BMI Calculator",
      img: IMG5,
      description:
        "A BMI calculator is a tool that helps you determine your body mass index.",
      technologies: "Html | CSS | javascript",
      link: "https://js-projects-bb5z.vercel.app/",
      github: "https://github.com/Vishal-k123/js-Projects/tree/main/07_Projects/BMI_Generator",
    },
    {
      id: 6,
      title: "Password Generator",
      img: IMG6,
      description:
        "A password generator is a tool that creates strong and secure passwords.",
      technologies: "Html | Tailwind | React js",
      link: "https://react-projects-ochre.vercel.app/",
      github: "https://github.com/Vishal-k123/React_Projects/tree/main/05PasswordGenerator",
    },
  ];

  return (
    <section id="portfolio">
      <h5>My Recent Work</h5>
      <h2>Portfolio</h2>

      <div className="container portfolio__container">
        {soloProjects.map((pro) => (
          <article className="portfolio__item" key={pro.id}>
            <div className="portfolio__item-image">
              <img src={pro.img} alt={pro.title} />
            </div>
            <div className="portfolio__item-content">
              <h3>{pro.title}</h3>
              <p>{pro.description}</p>
              <p>{pro.technologies}</p>
            </div>
            <div className="portfolio__item-cta">
              <a
                href={pro.github}
                target="_blank"
                className="btn"
                rel="noreferrer"
              >
                GitHub
              </a>
              <a
                href={pro.link}
                target="_blank"
                className="btn btn-primary"
                rel="noreferrer"
              >
                Live Demo
              </a>
            </div>
          </article>
        ))}
      </div>
    </section>
  );
};

export default Portfolio;
